import React, { useEffect, useState } from 'react';
import { fetchCombatSettings, saveLevelUpSkillPoints } from '../api/settings';
import { errorMessage } from '../api/client';

const FALLBACK = 5;

export function LevelUpPointsCard() {
  const [points, setPoints] = useState(FALLBACK);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    let cancel = false;
    fetchCombatSettings()
      .then((settings) => {
        if (cancel) return;
        const stored = settings.level_up_skill_points;
        if (typeof stored === 'number' && Number.isFinite(stored)) setPoints(stored);
      })
      .catch(() => {
        if (!cancel) setNotice('Vorgabe konnte nicht geladen werden.');
      });
    return () => {
      cancel = true;
    };
  }, []);

  const save = async () => {
    const next = Math.min(99, Math.max(0, Math.round(Number(points))));
    if (!Number.isFinite(next)) {
      setNotice('Bitte eine ganze Zahl von 0 bis 99.');
      return;
    }
    setBusy(true);
    setNotice(null);
    try {
      const saved = await saveLevelUpSkillPoints(next);
      const stored = saved.level_up_skill_points;
      setPoints(typeof stored === 'number' ? stored : next);
      setNotice('Gespeichert. Neue Levelaufstiege starten mit dieser Zahl.');
    } catch (err) {
      setNotice(errorMessage(err, 'Statpunkte konnten nicht gespeichert werden.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rule-form-card armor-formula-card">
      <h3>Levelaufstieg</h3>
      <p className="section-info">
        So viele Statpunkte schlägt der Spielleiter vor, wenn er einem Helden oder allen Helden
        einen Levelaufstieg gibt. Im Dialog kann die Zahl für diesen einen Aufstieg noch geändert werden.
      </p>
      <label htmlFor="level-up-skill-points">Statpunkte pro Levelaufstieg</label>
      <input
        id="level-up-skill-points"
        type="number"
        min={0}
        max={99}
        step={1}
        value={points}
        onChange={(event) => setPoints(Number(event.target.value))}
      />
      <div>
        <button type="button" className="medieval-button" disabled={busy} onClick={() => void save()}>
          {busy ? 'Speichert…' : 'Vorgabe speichern'}
        </button>
      </div>
      {notice && <p className="section-info">{notice}</p>}
    </div>
  );
}
